import { SenderDisabledBanner } from '@/pages/sender/sender-disabled-banner';
import { useSenderAccess } from '@/hooks/use-sender-access';
import type { ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';

interface SenderGateProps {
	children: ReactNode;
}

export default function SenderGate({ children }: SenderGateProps) {
	const { enabled, accessible, loading } = useSenderAccess();

	if (!enabled) {
		return <SenderDisabledBanner reason='disabled' />;
	}

	if (loading) {
		return (
			<div className='flex justify-center py-16'>
				<Spinner />
			</div>
		);
	}

	if (!accessible) {
		return <SenderDisabledBanner reason='token' />;
	}

	return <>{children}</>;
}
